import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PaginationState } from './pagination.state';

export const selectPaginationState = createFeatureSelector<PaginationState>('pagination');

export const selectPagination = createSelector(
  selectPaginationState,
  (state) => ({ pageNumber: state.pageNumber, pageSize: state.pageSize })
);
